import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useCreateBewerber } from '../../api/bewerber';
import { BewerberForm } from '../../components/bewerber/BewerberForm';
import { CreateBewerberDto } from '../../types/bewerber';

export function BewerberCreatePage() {
  const navigate = useNavigate();
  const createMutation = useCreateBewerber();

  const handleSubmit = async (data: CreateBewerberDto) => {
    try {
      const result = await createMutation.mutateAsync(data);
      toast.success('Bewerber erfolgreich erstellt');
      navigate(`/bewerber/${result.data.id}`);
    } catch (error) {
      console.error('Failed to create bewerber:', error);
      toast.error('Fehler beim Erstellen des Bewerbers');
    }
  };

  const handleCancel = () => {
    navigate('/bewerber');
  };

  return (
    <div>
      {/* Header */}
      <div className="mb-6">
        <Link to="/bewerber" className="text-sm text-gray-500 hover:text-gray-700 flex items-center mb-4">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Zurück zur Liste
        </Link>

        <h1 className="text-2xl font-bold text-gray-900">Neuer Bewerber</h1>
        <p className="mt-1 text-sm text-gray-500">
          Erfassen Sie einen neuen Bewerber für eine Schulbegleiter-Position
        </p>
      </div>

      <BewerberForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={createMutation.isPending}
      />
    </div>
  );
}
